import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-dark-950 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-dark-400 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          Zpět na hlavní stránku
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Ochrana osobních údajů</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-dark-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Správce údajů</h2>
            <p>
              Nakladatelství Olomouc s.r.o.<br />
              Vítězství 229/7, 779 00 Olomouc<br />
              IČO: 64612023
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Zpracovávané údaje</h2>
            <p>Zpracováváme: e-mail, údaje o platbách, výsledky testů a technické údaje (IP adresa, prohlížeč).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Účel zpracování</h2>
            <p>Údaje používáme pro poskytování služeb, správu účtu, zpracování plateb a zlepšování aplikace.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Doba uchování</h2>
            <p>Údaje uchováváme po dobu trvání účtu. Výsledky testů jsou automaticky mazány po 12 měsících.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Vaše práva</h2>
            <p>
              Máte právo na přístup k údajům, jejich opravu, výmaz, omezení zpracování
              a právo podat stížnost u ÚOOÚ.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Kontakt</h2>
            <p>
              <a href="mailto:info@synapso.cz" className="text-primary-400 hover:text-primary-300">
                info@synapso.cz
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">Podrobné GDPR</h2>
            <p>
              <a
                href="https://www.nakladatelstviolomouc.store/podminky-ochrany-osobnich-udaju/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-400 hover:text-primary-300"
              >
                Kompletní podmínky ochrany osobních údajů (GDPR)
              </a>
            </p>
          </section>

          <p className="text-dark-500 text-sm mt-8">
            Platné od 1. ledna 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
